import { useEffect } from "react";

export const useSeo = (seo) => {
    useEffect(() => {
        if (!seo) return;

        const prevTitle = document.title;
        const restores = [];

        if (seo.metaTitle) {
            document.title = seo.metaTitle;
        }

        const upsertMeta = (attr, key, value) => {
            if (!value) return;

            let el = document.head.querySelector(`meta[${attr}="${key}"]`);
            const created = !el;
            const previous = el?.getAttribute("content");

            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, key);
                document.head.appendChild(el);
            }

            el.setAttribute("content", value);
            restores.push({ el, created, previous });
        };

        const path =
            window.location.pathname === "/"
                ? "/"
                : window.location.pathname.replace(/\/+$/, "");

        const canonicalUrl =
            seo.canonicalUrl || `https://easilinked.com${path}`;

        const title = seo.socialTitle || seo.metaTitle;
        const description = seo.socialDescription || seo.metaDescription;

        upsertMeta("name", "description", seo.metaDescription);

        if (seo.noIndex) {
            upsertMeta("name", "robots", "noindex, nofollow");
        }

        upsertMeta("property", "og:type", "website");
        upsertMeta("property", "og:title", title);
        upsertMeta("property", "og:description", description);
        upsertMeta("property", "og:url", canonicalUrl);

        upsertMeta("name", "twitter:card", "summary");
        upsertMeta("name", "twitter:title", title);
        upsertMeta("name", "twitter:description", description);

        let canonical = document.head.querySelector('link[rel="canonical"]');
        const canonicalCreated = !canonical;
        const previousCanonical = canonical?.getAttribute("href");

        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }

        canonical.setAttribute("href", canonicalUrl);

        return () => {
            document.title = prevTitle;

            for (const { el, created, previous } of restores) {
                if (created) {
                    el.remove();
                } else if (previous !== null && previous !== undefined) {
                    el.setAttribute("content", previous);
                }
            }

            if (canonicalCreated) {
                canonical.remove();
            } else if (previousCanonical) {
                canonical.setAttribute("href", previousCanonical);
            }
        };
    }, [seo]);
};
